module.exports = __webpack_public_path__ + "img/electrical.d7b2aeaa.jpg";